import React, { useState, useEffect } from 'react';
import { Alert } from 'ui';
import QualCodeActions from 'actions/QualCodeActions';
import AuthStore from 'stores/AuthStore';
import PasswordModal from './PasswordModal';
import BillingModal from './BillingModal/BillingModal';
import TeamModal from './TeamModal';
import { Scrollbars } from 'react-custom-scrollbars';
import ProfileComponent from './ProfileComponent';
import SecurityComponent from './SecurityComponent';
import BillingComponent from './BillingComponent';
import TeamComponent from './TeamComponent';
import DataComponent from './DataComponent';
import { TeamModalProvider } from '../../contexts/TeamModalContext';
import { useToasts } from 'ui/toast';
import { useLocation, useHistory } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';

const LEFT_MARGIN = "30px";

const UserDisplay = () => {
  // Keep password state from AuthStore for now
  const [passwordState, setPasswordState] = useState(AuthStore.getPasswordState());
  const { addToast } = useToasts();
  const location = useLocation();
  const history = useHistory();
  const queryClient = useQueryClient();

  const changePassword = () => {
    QualCodeActions.showPasswordModal(true);
  };

  // Handle signup confirmation redirect (/users?account_confirmed=true)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('account_confirmed') === 'true') {
      addToast('Your email address has been confirmed!', { appearance: 'success' });
      queryClient.invalidateQueries({
        queryKey: ['users', 'current']
      });
      history.replace('/users');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Keep listening to AuthStore for password state changes
  useEffect(() => {
    const handleAuthChange = () => {
      setPasswordState(AuthStore.getPasswordState());
    };

    AuthStore.addChangeListener(handleAuthChange);

    return () => {
      AuthStore.removeChangeListener(handleAuthChange);
    };
  }, []);

  return (
    <TeamModalProvider>
      <Scrollbars autoHide>
        <div style={{ padding: "5px", height: "100%" }}>
          <PasswordModal passwordState={passwordState} />
          <BillingModal />
          <TeamModal />
          <div style={{ margin: `10px ${LEFT_MARGIN}` }}>
            {(passwordState.message && passwordState.success) &&
              <Alert variant="success">
                <p>
                  {passwordState.message}
                </p>
              </Alert>
            }
          </div>

          <ProfileComponent
            changePassword={changePassword}
          />
          <div>
            <BillingComponent />
            <TeamComponent />
            <SecurityComponent />
            <DataComponent />
          </div>
        </div>
      </Scrollbars>
    </TeamModalProvider>
  );
};

export default UserDisplay;
